module.exports = __webpack_public_path__ + "static/media/1a.eb1de054.jpg";